import React from 'react';

import { Grid, Typography } from '@mui/material';

import RoomPrice from '../RoomPrice';

import SubListAddRemove from './SubListAddRemove';

import RefundabilityDisplay from '../SeeRefundabilityParts/RefundabilityDisplay';

const DisplayAddedRemoved = ({
  modified,
  keyValue,
  id_product,
  check_in,
  isRefundable,
  isFromHotelBookingStyled,
  business_types,
  integration,
  ...props
}) => {
  const added = modified?.added;
  const removed = modified?.removed;

  const priceProps = {
    ...props,
    title: '',
    priceAlign: 'left',
    pricePaddingLeft: 10,
    id_product: id_product + 'cancelation-fee',
  };

  return (
    <React.Fragment>
      {'deadline' === keyValue &&
        Object.keys(modified).includes('CanBeCanceled') && (
          <React.Fragment>
            {modified?.CanBeCanceled?.added !== undefined && (
              <React.Fragment>
                <Typography style={{ fontSize: 15, padding: '0 5px' }}>
                  Ahora:
                </Typography>
                <RefundabilityDisplay
                  index={keyValue + 'added'}
                  check_in={check_in}
                  cancelationFee={{
                    CanBeCanceled: modified.CanBeCanceled.added,
                    DeadLineCancel: modified?.DeadLineCancel?.added,
                  }}
                  containerStyle={{ alignItems: 'start', paddingLeft: 15 }}
                  layout="inline"
                />
              </React.Fragment>
            )}
            {modified?.CanBeCanceled?.removed !== undefined && (
              <React.Fragment>
                <Typography style={{ fontSize: 15, padding: '0 5px' }}>
                  Antes:
                </Typography>
                <RefundabilityDisplay
                  index={keyValue + 'removed'}
                  check_in={check_in}
                  cancelationFee={{
                    CanBeCanceled: modified.CanBeCanceled?.removed,
                    DeadLineCancel: modified?.DeadLineCancel?.removed,
                  }}
                  containerStyle={{ alignItems: 'start', paddingLeft: 15 }}
                  layout="inline"
                />
              </React.Fragment>
            )}
          </React.Fragment>
        )}

      {'rate' === keyValue && added && removed && (
        <Grid
          container
          direction="row"
          spacing={1}
          alignItems="center"
          style={{ gap: 10 }}
        >
          {added && (
            <Grid item style={{ display: 'flex', alignItems: 'center' }}>
              <Typography style={{ fontSize: 16 }}>Ahora:</Typography>
              <RoomPrice
                {...priceProps}
                price={added}
                id_product={id_product + 'cancelation-fee-added'}
                priceColor="#03C868"
                business_types={business_types}
                integration={integration}
              />
            </Grid>
          )}

          {removed && (
            <Grid item style={{ display: 'flex', alignItems: 'center' }}>
              <Typography style={{ fontSize: 16 }}>Antes:</Typography>
              <RoomPrice
                {...priceProps}
                price={removed}
                id_product={id_product + 'cancelation-fee-removed'}
                business_types={business_types}
                integration={integration}
              />
            </Grid>
          )}
        </Grid>
      )}

      {['cancellation_policies'].includes(keyValue) && (
        <React.Fragment>
          <SubListAddRemove
            modified={added}
            title={'Nuevo:'}
            color={'cancellation_policies' === keyValue ? '#03C868' : 'black'}
          />
          <SubListAddRemove
            modified={removed}
            title={'Antes:'}
            color={'cancellation_policies' === keyValue ? '#EC2E20' : 'black'}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default DisplayAddedRemoved;
